export const selectFirstNotification = (state) => state.notification.notifications[0];
